var styles = {"chatbot-footer":"footer-module_chatbot-footer__UpOmN","maximized-width":"footer-module_maximized-width__8HH0j","footer-text":"footer-module_footer-text__SgM7r","first-line":"footer-module_first-line__pAgir","separator":"footer-module_separator__sgfzc","link-text":"footer-module_link-text__-a0-6"};

export { styles as default };
